module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "footer-main"
    }
  }, [_c('div', {
    attrs: {
      "id": "footer-top"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "list-container"
  }, [_c('h4', {
    staticClass: "footer-titles"
  }, [_vm._v("Dúvidas")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "scrollup",
    attrs: {
      "to": {
        name: 'FAQ'
      }
    }
  }, [_vm._v("\n              Perguntas Frequentes\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "scrollup",
    attrs: {
      "to": {
        name: 'guide'
      }
    }
  }, [_vm._v("\n              Guia de Instalação do TAG\n            ")])], 1), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sales"
    }
  }, [_c('h4', {
    staticClass: "footer-titles"
  }, [_vm._v("Central de Vendas")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("./phone.svg")
    }
  }), _vm._v(" "), _c('h5', [_vm._v("0800 777 1022")])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("./phone.svg")
    }
  }), _vm._v(" "), _c('h5', [_vm._v("4000 2901")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "phone-container"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("./whatsapp.svg")
    }
  }), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "https://wa.me/5511981192574",
      "target": "_blank"
    }
  }, [_vm._v("WhatsApp\n              ")])])]), _vm._v(" "), _c('div', [_c('h6', [_c('a', {
    attrs: {
      "href": "https://www.movemais.com",
      "target": "_blank"
    }
  }, [_vm._v("Visite-nos\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-container"
  }, [_c('h4', {
    staticClass: "footer-titles"
  }, [_vm._v("Políticas")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
      "target": "_blank"
    }
  }, [_vm._v("Termos e Condições\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Aviso de Privacidade\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/politica-de-cookies-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Política de Cookies\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/politica-de-reembolso-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Política de Reembolso\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/regulamento-da-campanha-adesao-gratis-movemais-roadcard",
      "target": "_blank"
    }
  }, [_vm._v("\n              Regulamento da campanha\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-container"
  }, [_c('h4', {
    staticClass: "footer-titles"
  }, [_vm._v("Compliance")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/codigo-de-conduta-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Código de Conduta\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.contatoseguro.com.br/movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Canal de Ética\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/requisitos-pre-aprovacao-provedores-externos-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Requisitos Fornecedores\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Tarifas Move Mais\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer-bottom"
    }
  }, [_c('div', {
    staticClass: "footer-bottom-container",
    attrs: {
      "id": "app-download"
    }
  }, [_c('h4', {
    staticClass: "footer-titles"
  }, [_vm._v("Baixe nosso App")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://apps.apple.com/br/app/move-mais-ped%C3%A1gio-free-flow/id6747896915",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./appStore.svg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.movemais.morfeu",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./googlePlay.svg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom-container"
  }, [_c('h4', {
    staticClass: "footer-titles",
    attrs: {
      "id": "social-media-container"
    }
  }, [_vm._v("\n          Acompanhe-nos\n        ")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/MoveMais/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./facebook.svg"),
      "alt": "Facebook"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/movemais/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./instagram.svg"),
      "alt": "Instagram"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/move-mais/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./linkedin.svg"),
      "alt": "LinkedIn"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/Move_Mais",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./twitter.svg"),
      "alt": "Twitter"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/movemais",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./youtube.svg"),
      "alt": "YouTube"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom-container"
  }, [_c('h4', {
    staticClass: "footer-titles"
  }, [_vm._v("Certificado")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./sectigo-siteseal.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom-container"
  }, [_c('h4', {
    staticClass: "footer-titles"
  }, [_vm._v("Consumidor")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://consumidor.gov.br",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./consumidor.gov.svg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom-container"
  }, [_c('h4', {
    staticClass: "footer-titles"
  }, [_vm._v("Reputação")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "reputation-ra"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer-text-container"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./logo_Move_Mais_v3_contorno.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        © 2023 Todos os direitos reservados. Av. Rodrigo Fernando Grillo, 207,\n        Edifício Victoria Business, 20º andar - Araraquara-SP.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-ded62108!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/hotsite/components/footer/footer.vue
// module id = 2221
// module chunks = 1